export default "__VITE_ASSET__DJs8Oizk__"